export default "__VITE_ASSET__f7fvNf7c__"